import { ProductFeatureModelDto } from '@treasury/api/bo';
import { CompanyOptionModel } from '../../../../../arp/company-option-model.entity';
import { PositivePayType } from '../../../../types/positive-pay/positive-pay.types';
import { CompanyProductFeature } from './company-product-feature.entity';
import { ProductFeatureAccountParticipation } from './product-feature-account-participation.entity';
import { ProductFeatureAccount } from './product-feature-account.entity';

// TODO: BareBones implementation, do not discard. Will be fleshed out in subsequent PRs.
export class PositivePayProductFeature extends CompanyProductFeature<ProductFeatureModelDto> {
    private _companyOptions: CompanyOptionModel[] = [];

    private _allowCheckExceptions = false;

    private _allowIssuedItems = false;

    private _allowCorrectionRequest = false;

    private _allowReturnReason = false;

    private _allowAchExceptions = false;

    private _allowAchFilterRules = false;

    private _productFeatureAccounts: ProductFeatureAccount[] = [];

    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get accounts(): ProductFeatureAccount[] {
        return this._productFeatureAccounts;
    }

    public set accounts(value: ProductFeatureAccount[]) {
        this._productFeatureAccounts = value;
    }

    public get allowCheckExceptions() {
        return this._allowCheckExceptions;
    }

    public set allowCheckExceptions(value: boolean) {
        this._allowCheckExceptions = value;
        this.setOption('PositivePay.WorkCheckExceptions', value);
    }

    public get allowIssuedItems() {
        return this._allowIssuedItems;
    }

    public set allowIssuedItems(value: boolean) {
        this._allowIssuedItems = value;
        this.setOption('PositivePay.AllowIssuedItemActivityReview', value);
    }

    public get allowCorrectionRequest() {
        return this._allowCorrectionRequest;
    }

    public set allowCorrectionRequest(value: boolean) {
        this._allowCorrectionRequest = value;
        this.setOption('PositivePay.CheckException.AllowCorrectionRequest', value);
    }

    public get allowReturnReason() {
        return this._allowReturnReason;
    }

    public set allowReturnReason(value: boolean) {
        this._allowReturnReason = value;
        this.setOption('PositivePay.CheckException.AllowReturnReason', value);
    }

    public get allowAchExceptions() {
        return this._allowAchExceptions;
    }

    public set allowAchExceptions(value: boolean) {
        this._allowAchExceptions = value;
        if (!value) {
            this._allowAchFilterRules = false;
            this.setOption('PositivePay.ACHFilterManagement.AllowManageAchFilters', false);
        }
        this.setOption('PositivePay.ShowAchExceptions', value);
    }

    public get allowAchFilterRules() {
        return this._allowAchFilterRules;
    }

    public set allowAchFilterRules(value: boolean) {
        this._allowAchFilterRules = value;
        this.setOption('PositivePay.ACHFilterManagement.AllowManageAchFilters', value);
    }

    public get companyOptions() {
        return this._companyOptions;
    }

    public set companyOptions(value: CompanyOptionModel[]) {
        this._companyOptions = value;

        this._allowCheckExceptions = this.isOptionEnabled('PositivePay.WorkCheckExceptions');
        this._allowIssuedItems = this.isOptionEnabled('PositivePay.AllowIssuedItemActivityReview');
        this._allowCorrectionRequest = this.isOptionEnabled(
            'PositivePay.CheckException.AllowCorrectionRequest'
        );
        this._allowReturnReason = this.isOptionEnabled(
            'PositivePay.CheckException.AllowReturnReason'
        );
        this._allowAchExceptions = this.isOptionEnabled('PositivePay.ShowAchExceptions');
        this._allowAchFilterRules = this.isOptionEnabled(
            'PositivePay.ACHFilterManagement.AllowManageAchFilters'
        );
    }

    public get productFeatureAccounts() {
        return this._productFeatureAccounts;
    }

    public updateProductFeatureAccounts(
        accountType: PositivePayType,
        accounts: ProductFeatureAccountParticipation[]
    ) {
        const existingAccount = this._productFeatureAccounts.find(
            account => account.featureName === this.getFeatureNameFromType(accountType)
        );
        if (existingAccount) {
            existingAccount.featureParticipations = accounts;
        } else {
            const feature = new ProductFeatureAccount({
                featureName: this.getFeatureNameFromType(accountType),
                featureParticipations: accounts.map(account => account.toDto()),
            });
            this._productFeatureAccounts.push(feature);
        }
    }

    private setOption(optionName: string, value: boolean) {
        const option = this._companyOptions.find(option => option.name === optionName);
        if (option) {
            option.value = value ? '1' : '0';
        } else {
            this._companyOptions.push(
                new CompanyOptionModel({
                    name: optionName,
                    value: value ? '1' : '0',
                })
            );
        }
    }

    private isOptionEnabled(optionName: string): boolean {
        const option = this._companyOptions.find(option => option.name === optionName);
        return option ? option.value === '1' : false;
    }

    private getFeatureNameFromType(type: PositivePayType): string {
        switch (type) {
            case PositivePayType.Check:
                return 'WorkCheckExceptions';
            case PositivePayType.Ach:
                return 'WorkACHExceptions';
            case PositivePayType.AchFilters:
                return 'ACHFilterManagement';
            default:
                throw new Error(`Unknown PositivePayType: ${type}`);
        }
    }
}
